// extracted by mini-css-extract-plugin
export default {"mainBackgroundCover":"modal_mainBackgroundCover__nrXoT","mainModal":"modal_mainModal__MDjp1","AiOutlineClose":"modal_AiOutlineClose__XpJmf"};